import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ExpandDownProps {
  className?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
  disabled?: boolean;
}

const ExpandDownIcon = function ExpandDownIcon({
  className,
  width,
  height,
  onClick,
  disabled,
}: ExpandDownProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge(className, disabled && 'opacity-50')}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      onClick={disabled ? () => {} : onClick}
    >
      <path d="M15 7.5L10 12.5L5 7.5" stroke="#828A97" className="fill-transparent" />
    </svg>
  );
};

ExpandDownIcon.defaultProps = {
  className: '',
  width: 20,
  onClick: () => {},
  height: 20,
  disabled: false,
};

export default ExpandDownIcon;
